export const CART_EVENTO_KEY = "webgula-cart-evento";

export function checkoutCart() {
  localStorage.removeItem(CART_EVENTO_KEY);
}
